class FamiliaProductoPropiedad
{
  idFamiliaProductoPropiedad = 0;
  //valorPropiedad = "";
  familiaProducto_idFamiliaProducto = 0;
  propiedadFamilia_idPropiedadFamiliaProducto = 0;
  tipo = "image";

  constructor(obj = {}) {
    Object.assign(this, obj);
  }
}

module.exports = FamiliaProductoPropiedad;
